<template>
  <div class="empty-state">
    <div class="empty-state__logo-wrap">
      <img
        class="empty-state__logo"
        src="../../../../logo2.png"
        alt="Compopo"
      >
    </div>
    <h3 v-if="title" class="empty-state__title">{{ title }}</h3>
    <p v-if="message" class="empty-state__message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1.5rem;
  text-align: center;
}

.empty-state__logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.5rem;
  height: 5.5rem;
  margin-bottom: 1.25rem;
  border-radius: 9999px;
  background: linear-gradient(135deg, rgba(239, 246, 255, 0.9), rgba(255, 255, 255, 0.95));
  box-shadow:
    0 4px 24px rgba(37, 99, 235, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  animation: empty-float 3s ease-in-out infinite;
}

.empty-state__logo {
  width: 3.5rem;
  height: auto;
  object-fit: contain;
  animation: empty-bob 3s ease-in-out infinite;
}

.empty-state__title {
  margin: 0 0 0.5rem;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
}

.empty-state__message {
  margin: 0;
  max-width: 18rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #64748b;
}

@keyframes empty-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

@keyframes empty-bob {
  0%, 100% { transform: scale(1) rotate(0deg); }
  25% { transform: scale(1.03) rotate(-2deg); }
  75% { transform: scale(1.03) rotate(2deg); }
}
</style>
